import { useRouter } from "next/router";
import { useEffect } from "react";

export default function Home() {
  const router = useRouter();
  useEffect(() => {
    let { asPath } = router;

    // ignore the fragment identifier if it exists
    asPath = asPath.split("#")[0];

    if (!asPath || asPath === "/") {
      router.push("/notifications");
    } else {
      router.push(asPath);
    }
  }, [router]);

  return <></>;
}
